import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../home/Home.vue"),
  },
  {
    path: "/memberCenter",
    name: "MemberCenter",
    component: () => import("../home/MemberCenter.vue"),
  },
  {
    path: "/applyMember",
    name: "ApplyMember",
    component: () => import("../home/ApplyMember.vue"),
  },
  {
    path: "/policiesRegulations",
    name: "PoliciesRegulations",
    component: () => import("../home/PoliciesRegulations.vue"),
  },
  {
    path: "/overView",
    name: "overView",
    component: () => import("../overView/overView.vue"),
  },
  {
    path: "/noticeDetail",
    name: "NoticeDetail",
    component: () => import("../home/NoticeDetail.vue"),
  },
  {
    path: "/announcement",
    name: "announcement",
    component: () => import("../announcement/announcement.vue"),
  },
  {
    path: "/consultationUpdates",
    name: "consultationUpdates",
    component: () => import("../consultationUpdates/consultationUpdates.vue"),
  },
  {
    path: "/consultationUpdatesDetail/detail",
    name: "consultationUpdatesDetail",
    component: () => import("../consultationUpdates/detail/detail.vue")
  }
  ,
  {
    path: "/policiesRegulationsDetail",
    name: "PoliciesRegulationsDetail",
    component: () => import("../home/PoliciesRegulationsDetail.vue"),
  },
  {
    path: "/MemberCenterDetail",
    name: "MemberCenterDetail",
    component: () => import("../home/MemberCenterDetail.vue"),
  },
  {
    path: "/detail1",
    name: "detailPage",
    component: () => import("../home/detail1.vue"),
  },
  {
    path: "/detail2",
    name: "detailPage2",
    component: () => import("../home/detail2.vue"),
  },
  {
    path: "/detail3",
    name: "detailPage3",
    component: () => import("../home/detail3.vue"),
  },
    {
      path: "/testMap",
      name: "testMap",
      component: () => import("../home/testMap.vue"),
    },
  //   {
  //     path: "*",
  //     component: () => import("../views/error.vue"),
  //   },
];

export default new Router({
  mode: "hash",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
